export async function getTrackStatsCalculator() {
    // Ambient module declaration is in @gaia/types/TrackStatsCalculator.d.ts
    const {default: Calculator}: TrackStatsCalculatorModule = await import('TrackStats/Calculator');
    return new Calculator();
}
